import { render, staticRenderFns } from "./RestaurantsList.vue?vue&type=template&id=214963c4&scoped=true&"
import script from "./RestaurantsList.vue?vue&type=script&lang=js&"
export * from "./RestaurantsList.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantsList.vue?vue&type=style&index=0&id=214963c4&lang=scss&scoped=true&"
import style1 from "./RestaurantsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214963c4",
  null
  
)

export default component.exports